<template>
  <div class="imageEditor">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="d-flex justify-content-between mb-3">
            <b-form-file
              placeholder="Escolha uma imagem"
              drop-placeholder="Arraste o arquivo aqui..."
              browse-text="Procurar"
              accept="image/jpeg, image/png, image/jpg"
              :disabled="uploadingImage"
              v-on:change="uploadImage"
              class="col-8"
            ></b-form-file>
            <button
              class="btn btn-secondary col-3"
              :disabled="loadingFolders"
              @click="handleOpenModal"
            >
              <b-spinner v-if="loadingFolders" small class="mr-2"></b-spinner>
              {{ loadingFolders ? "Carregando..." : "Selecionar do arquivo" }}
            </button>
          </div>
          <div class="editor-toolbar d-flex align-items-center mb-2" v-if="canvas">
            <button class="btn btn-light mr-2" @click="setMode('draw')" title="Lápis">
              <font-awesome-icon icon="pencil-alt" />
            </button>
            <button class="btn btn-light mr-2" @click="addRect" title="Retângulo">
              <font-awesome-icon icon="square" />
            </button>
            <button class="btn btn-light mr-2" @click="addCircle" title="Círculo">
              <font-awesome-icon icon="circle" />
            </button>
            <button class="btn btn-light mr-2" @click="addArrow" title="Seta">
              <font-awesome-icon icon="arrow-right" />
            </button>
            <button class="btn btn-light mr-2" @click="startCrop" title="Cortar">
              <font-awesome-icon icon="crop" />
            </button>
            <button v-if="showCropBtn" class="btn btn-primary mr-2" @click="applyCrop" title="Aplicar Corte">
              Aplicar Corte
            </button>
            <input type="color" v-model="color" class="ml-2" style="width: 32px; height: 32px; border: none; background: none;" />
            <button class="btn btn-danger ml-2" @click="deleteSelected" title="Apagar Selecionado">
              <font-awesome-icon icon="trash" />
            </button>
          </div>
          <div class="canvas-container">
            <canvas id="fabric-canvas" width="600" height="400"></canvas>
          </div>
        </div>
      </div>
      <div class="row" v-show="false">
      </div>
    </div>

    <AttachmentViewer
      v-model="showImageModal"
      :attachments="folder.attachments"
      :startIndex="currentImageIdx"
      @select="handleSelectImage"
    />

    <b-modal
      id="directory-modal"
      ref="directoryModal"
      title="Selecionar Arquivo"
      size="lg"
      :hide-footer="false"
      no-enforce-focus
      @ok="selectImageFromDirectory"
      modal-class="image-editor-modal"
    >
      <div class="container-fluid">
        <div class="row" style="font-size: 18px; margin-bottom: 8px">
          <div class="col-6">
            <font-awesome-icon
              style="margin-right: 8px; color: #f2671c"
              icon="folder-open"
            />
            <span>{{ folder.name ? folder.name : "Diretórios" }}</span>
          </div>
          <div class="col-6">
            <div class="w-100 d-flex justify-content-end">
              <div
                class="return"
                v-if="folder.id"
                v-on:click="
                  openFolder(
                    folder.ancestor ? folder.ancestor.id : 'root'
                  )
                "
              >
                <font-awesome-icon icon="angle-left" />Voltar
              </div>
            </div>
          </div>
        </div>
        <div
          class="row"
          style="max-height: 60vh; overflow: auto"
          v-if="renderFolders"
        >
          <div
            class="col-12"
            v-for="subFolder in folder.descendants"
            v-bind:key="subFolder.id"
            v-on:click="openFolder(subFolder.id)"
          >
            <FolderItem
              type="folder"
              :name="subFolder.name"
              :id="subFolder.id"
            ></FolderItem>
          </div>
          <div
            class="col-12"
            v-for="file in folder.attachments"
            v-bind:key="file.id"
          >
            <FolderItem
              type="file"
              :name="file.name"
              :size="formatNumber(file.size / 1000) + 'KB'"
              :id="file.id"
              :url="file.url"
              :mimeType="file.mime_type"
              canSelect
              :selected="isSelectedItem(file.id)"
              @selectItem="selectItem"
            ></FolderItem>
          </div>
        </div>
        <div
          v-if="!renderFolders"
          class="w-100 d-flex justify-content-center align-items-center"
          style="margin-top: 30px; margin-bottom: 30px"
        >
          <b-spinner
            style="margin-right: 15px"
            label="Small Spinner"
          ></b-spinner>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import axios from "@/api/axios";
import FolderItem from "@/components/FolderItem.vue";
import '@/styles/ModalImageEditor.scss';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faAngleLeft, faArrowRight, faCircle, faCrop, faFolderOpen, faFont, faPencilAlt, faSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import AttachmentViewer from "./AttachmentViewer/AttachmentViewer.vue";
const fabric = require('fabric').fabric;

library.add(faTrash, faPencilAlt, faSquare, faCircle, faArrowRight, faFont, faCrop, faFolderOpen, faAngleLeft);

if (!fabric.Arrow) {
  fabric.Arrow = fabric.util.createClass(fabric.Line, {
    type: 'arrow',
    initialize: function (points, options) {
      options || (options = {});
      this.callSuper('initialize', points, options);
    },
    _render: function (ctx) {
      this.callSuper('_render', ctx);
      // Desenha a cabeça da seta
      var xDiff = this.x2 - this.x1;
      var yDiff = this.y2 - this.y1;
      var angle = Math.atan2(yDiff, xDiff);
      ctx.save();
      ctx.translate(this.x2 - this.x1, this.y2 - this.y1);
      ctx.rotate(angle);
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.lineTo(-15, -7);
      ctx.lineTo(-15, 7);
      ctx.closePath();
      ctx.fillStyle = this.stroke;
      ctx.fill();
      ctx.restore();
    }
  });
}

export default {
  name: "ImagemEditor",
  components: {
    FontAwesomeIcon,
    FolderItem,
    AttachmentViewer
  },
  props: {
    machine_id: {
      type: String,
      default: null
    },
    selectedDirectory: {
      type: String,
      default: null
    },
    documentType: {
      type: String,
      default: null
    },
    company_id: {
      type: String,
      default: () => localStorage.getItem('company_id'),
    }
  },
  data() {
    return {
      tempImage: '',
      canvas: null,
      color: '#F32E2E',
      mode: 'select',
      folder: {},
      renderFolders: true,
      existsAttachmentList: [],
      cropRect: null,
      showCropBtn: false,
      showEditor: true,

      showImageModal: false,
      currentImageIdx: 0,
      lastSelectedAttachmentId: null,
      hasRealImage: false,
      uploadingImage: false,
      loadingFolders: false,
    };
  },
  async mounted() {
    this.initCanvas();
    window.addEventListener('keydown', this.handleDeleteKey);

    await this.loadFoldersAndOpenViewer();
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleDeleteKey);
  },
  methods: {
    async handleOpenModal() {
      await this.loadFoldersAndOpenViewer();
    },
    async loadFoldersAndOpenViewer() {
      if (this.loadingFolders) return;

      this.loadingFolders = true;
      try {
        await this.getFolders();
        let idx = 0;
        if (this.lastSelectedAttachmentId && this.folder.attachments) {
          const found = this.folder.attachments.findIndex(a => a.id === this.lastSelectedAttachmentId);
          if (found >= 0) idx = found;
        } else if (typeof this.currentImageIdx === 'number' && this.folder.attachments && this.folder.attachments[this.currentImageIdx]) {
          idx = this.currentImageIdx;
        }
        this.currentImageIdx = idx;
        this.showImageModal = true;
      } finally {
        this.loadingFolders = false;
      }
    },
    initCanvas() {
      this.canvas = new fabric.Canvas('fabric-canvas', {
        isDrawingMode: false,
        backgroundColor: 'transparent',
      });
      
      fabric.Object.prototype.borderColor = 'transparent';
      fabric.Object.prototype.cornerColor = 'transparent';
      fabric.Object.prototype.cornerStrokeColor = 'transparent';
      
      fabric.Object.prototype.hasBorders = false;
      fabric.Object.prototype.hasControls = false;
      fabric.Object.prototype.stroke = 'transparent';
      fabric.Object.prototype.strokeWidth = 0;
      
      this.canvas.freeDrawingBrush.color = this.color;
      this.canvas.freeDrawingBrush.width = 3;
      this.canvas.on('mouse:down', (opt) => {
        if (this.mode === 'arrow') {
          const pointer = this.canvas.getPointer(opt.e);
          const points = [pointer.x, pointer.y, pointer.x + 50, pointer.y + 50];
          const arrow = new fabric.Line(points, {
            strokeWidth: 3,
            fill: this.color,
            stroke: this.color,
            originX: 'center',
            originY: 'center',
          });
          this.canvas.add(arrow);
        }
      });
    },

    async handleSelectImage(payload) {
      const image = payload?.image || payload;
      if (payload && typeof payload.index === 'number') {
        this.currentImageIdx = payload.index;
      }
      if (image?.id) {
        this.lastSelectedAttachmentId = image.id;
      }
      if (!image?.url) return;

      // converte URL para blob
      const response = await fetch(decodeURIComponent(image.url));
      const blob = await response.blob();

      if (!blob.type.includes("image/")) return;

      const reader = new FileReader();
      reader.onload = (event) => {
        fabric.Image.fromURL(event.target.result, (img) => {
          const maxWidth = 600;
          const maxHeight = 400;

          const scaleX = maxWidth / img.width;
          const scaleY = maxHeight / img.height;
          const scale = Math.min(scaleX, scaleY, 1);

          const canvasWidth = img.width * scale;
          const canvasHeight = img.height * scale;

          this.canvas.setWidth(canvasWidth);
          this.canvas.setHeight(canvasHeight);

          img.borderColor = "transparent";
          img.cornerColor = "transparent";
          img.cornerStrokeColor = "transparent";
          img.hasBorders = false;
          img.hasControls = false;
          img.selectable = false;

          this.canvas.setBackgroundImage(
            img,
            this.canvas.renderAll.bind(this.canvas),
            {
              scaleX: scale,
              scaleY: scale,
              originX: "left",
              originY: "top"
            }
          );

          this.canvas.backgroundColor = "transparent";
          this.canvas.renderAll();
        });
        this.tempImage = event.target.result;
        this.hasRealImage = true;
      };
      reader.readAsDataURL(blob);
    },

    async uploadImage(e) {
      const file = e.target.files[0];
      if (!file || !file.type.includes('image/')) return;

      this.uploadingImage = true;

      try {
        if (this.selectedDirectory) {
          if (!this.folder.id) {
            await this.getFolders();
          }

          if (!this.folder.id) {
            throw new Error("Diretório de destino não encontrado");
          }

          const directoryId = this.folder.id;
          const formData = new FormData();
          formData.append("file", file);
          formData.append("directory_id", directoryId);
          formData.append("company_id", this.company_id);
          formData.append("name", file.name);
          formData.append("machine_id", this.machine_id);

          await axios.postForm(
            `${process.env.VUE_APP_API_HOST}/api/admin/attachments/formdata`,
            formData
          );
          await this.openFolder(directoryId);
        }

        this.loadImageFile(file);
      } catch {
        this.$bvToast.toast(
          `Não foi possível salvar a imagem na pasta ${this.selectedDirectory}. Por favor tente novamente!`,
          {
            title: `Ocorreu um erro`,
            toaster: "b-toaster-top-center",
            solid: true,
            variant: "danger",
          }
        );
      } finally {
        this.uploadingImage = false;
      }
    },
    loadImageFile(file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        fabric.Image.fromURL(event.target.result, (img) => {
          const maxWidth = 600;
          const maxHeight = 400;
          
          const scaleX = maxWidth / img.width;
          const scaleY = maxHeight / img.height;
          const scale = Math.min(scaleX, scaleY, 1); // Não aumenta a imagem
          
          const canvasWidth = img.width * scale;
          const canvasHeight = img.height * scale;
          
          this.canvas.setWidth(canvasWidth);
          this.canvas.setHeight(canvasHeight);
          
          img.borderColor = 'transparent';
          img.cornerColor = 'transparent';
          img.cornerStrokeColor = 'transparent';
          img.hasBorders = false;
          img.hasControls = false;
          img.selectable = false;
          
          this.canvas.setBackgroundImage(img, this.canvas.renderAll.bind(this.canvas), {
            scaleX: scale,
            scaleY: scale,
            originX: 'left',
            originY: 'top'
          });
          
          // Força remoção de bordas
          this.canvas.backgroundColor = 'transparent';
          this.canvas.renderAll();
        });
        this.tempImage = event.target.result;
        this.hasRealImage = true;
      };
      reader.readAsDataURL(file);
    },
    setMode(mode) {
      this.mode = mode;
      this.canvas.isDrawingMode = mode === 'draw';
      this.canvas.freeDrawingBrush.color = this.color;
    },
    addRect() {
      const rect = new fabric.Rect({
        left: 100, top: 100, fill: 'transparent', stroke: this.color, width: 80, height: 60, strokeWidth: 3
      });
      this.canvas.add(rect);
    },
    addCircle() {
      const circle = new fabric.Circle({
        left: 200, top: 200, radius: 40, fill: 'transparent', stroke: this.color, strokeWidth: 3
      });
      this.canvas.add(circle);
    },
    addArrow() {
      this.canvas.isDrawingMode = false;
      const x1 = 100, y1 = 100, x2 = 200, y2 = 200;
      const line = new fabric.Line([x1, y1, x2, y2], {
        stroke: this.color,
        strokeWidth: 3,
        selectable: false,
        evented: false
      });
      // Calcula o ângulo da linha
      const angle = Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI;
      // Cabeça da seta (triângulo)
      const triangle = new fabric.Triangle({
        left: x2,
        top: y2,
        angle: angle + 90,
        width: 20,
        height: 20,
        fill: this.color,
        originX: 'center',
        originY: 'center',
        selectable: false,
        evented: false
      });
      const arrow = new fabric.Group([line, triangle], {
        left: 0,
        top: 0,
        selectable: true
      });
      this.canvas.add(arrow);
      this.canvas.setActiveObject(arrow);
    },
    saveImage() {
      const dataUrl = this.canvas.toDataURL({ format: 'png' });
      // Aqui você pode emitir o dataUrl para o parent ou salvar
      // Exemplo: this.$emit('save', dataUrl);
      window.open(dataUrl, '_blank');
    },
    showDirectoryModal() {
      this.getFolders();
      this.$refs.directoryModal.show();
    },
    async getFolders() {
      this.renderFolders = false;
      let url = this.machine_id
        ? `${process.env.VUE_APP_API_HOST}/api/admin/directories?filter[machine_id]=${this.machine_id}&filter[where_is_root]=1`
        : `${process.env.VUE_APP_API_HOST}/api/admin/directories?filter[company_id]=${this.company_id}&filter[where_is_root]=1`;
      await axios
        .get(url, {
          params: {
            page: 1,
            per_page: 100,
          },
        })
        .then(async (response) => {
          this.folder.descendants = response.data.data;
          this.folder.attachments = [];
          this.renderFolders = true;
          if (this.selectedDirectory) {
            let photoDirectory = response.data.data.find((item) => item.name === this.selectedDirectory);
            if (!photoDirectory) {
              // Pasta padrão ainda não existe para esta máquina (ex.: primeira vez que
              // essa máquina recebe uma foto por aqui) - cria automaticamente.
              photoDirectory = await this.createDefaultDirectory();
            }
            if (photoDirectory) {
              await this.openFolder(photoDirectory.id);
            }
          }
        })
        .catch(() => {
          this.renderFolders = true;
          this.$bvToast.toast(
            `Desculpe, tivemos algum problema. Por favor tente novamente!`,
            {
              title: `Ocorreu um erro`,
              toaster: "b-toaster-top-center",
              solid: true,
              variant: "danger",
            }
          );
        });
    },
    createDefaultDirectory() {
      return axios
        .post(`${process.env.VUE_APP_API_HOST}/api/admin/directories/`, {
          name: this.selectedDirectory,
          company_id: this.company_id,
          machine_id: this.machine_id,
        })
        .then((response) => response.data.data || response.data)
        .catch(() => null);
    },
    async openFolder(folder_id) {
      if (folder_id == 'root') {
        this.folder = {};
        return await this.getFolders();
      }
      this.renderFolders = false;
      await axios
        .post(
          `${process.env.VUE_APP_API_HOST}/api/admin/get-attachments-by-machine`,
          { directory_id: folder_id, machine_id: this.machine_id }
        )
        .then((response) => {
          this.folder = response.data;
          this.renderFolders = true;
        })
        .catch(() => {
          this.renderFolders = true;
          this.$bvToast.toast(
            `Desculpe, tivemos algum problema. Por favor tente novamente!`,
            {
              title: `Ocorreu um erro`,
              toaster: "b-toaster-top-center",
              solid: true,
              variant: "danger",
            }
          );
        });
    },
    formatNumber(n) {
      let t = parseFloat(n).toFixed(1);
      return t.replace('.', ',');
    },
    selectItem(id, value) {
      if (value) {
        this.existsAttachmentList.push(id);
      } else {
        let index = this.existsAttachmentList.indexOf(id);
        this.existsAttachmentList.splice(index, 1);
      }
    },
    isSelectedItem(id) {
      return this.existsAttachmentList.indexOf(id) >= 0;
    },
    selectImageFromDirectory() {
      if (this.existsAttachmentList.length > 0) {
        axios
          .get(
            `${process.env.VUE_APP_API_HOST}/api/admin/attachments/${this.existsAttachmentList[0]}`
          )
                  .then((response) => {
          const imageUrl = response.data.data.url;
          
          // Convert image URL to base64 to avoid CORS issues
          fetch(imageUrl)
            .then(response => response.blob())
            .then(blob => {
              const reader = new FileReader();
              reader.onloadend = () => {
                fabric.Image.fromURL(reader.result, (img) => {
                  const maxWidth = 600;
                  const maxHeight = 400;
                  
                  const scaleX = maxWidth / img.width;
                  const scaleY = maxHeight / img.height;
                  const scale = Math.min(scaleX, scaleY, 1); // Não aumenta a imagem
                  
                  const canvasWidth = img.width * scale;
                  const canvasHeight = img.height * scale;
                  
                  this.canvas.setWidth(canvasWidth);
                  this.canvas.setHeight(canvasHeight);
                  
                  this.canvas.setBackgroundImage(img, this.canvas.renderAll.bind(this.canvas), {
                    scaleX: scale,
                    scaleY: scale,
                    originX: 'left',
                    originY: 'top'
                  });
                });
                this.tempImage = reader.result;
                this.hasRealImage = true;
                this.existsAttachmentList = [];
                this.$refs.directoryModal.hide();
              };
              reader.readAsDataURL(blob);
            })
            .catch(() => {
              this.$bvToast.toast(
                `Desculpe, tivemos algum problema ao carregar a imagem. Por favor tente novamente!`,
                {
                  title: `Ocorreu um erro`,
                  toaster: "b-toaster-top-center",
                  solid: true,
                  variant: "danger",
                }
              );
            });
        })
          .catch(() => {
            this.$bvToast.toast(
              `Desculpe, tivemos algum problema. Por favor tente novamente!`,
              {
                title: `Ocorreu um erro`,
                toaster: "b-toaster-top-center",
                solid: true,
                variant: "danger",
              }
            );
          });
      }
    },
    deleteSelected() {
      const activeObject = this.canvas.getActiveObject();
      if (activeObject) {
        this.canvas.remove(activeObject);
      }
    },
    handleDeleteKey(e) {
      const activeObject = this.canvas.getActiveObject();
      if (
        (e.key === 'Delete' || e.key === 'Backspace') &&
        (!activeObject || activeObject.type !== 'i-text' || !activeObject.isEditing)
      ) {
        this.deleteSelected();
      }
    },
    startCrop() {
      // Adiciona um retângulo de crop editável
      if (this.cropRect) {
        this.canvas.setActiveObject(this.cropRect);
        return;
      }
      const width = this.canvas.getWidth() / 2;
      const height = this.canvas.getHeight() / 2;
      const left = this.canvas.getWidth() / 4;
      const top = this.canvas.getHeight() / 4;
      this.cropRect = new fabric.Rect({
        left,
        top,
        width,
        height,
        fill: 'transparent',
        stroke: '#666',
        strokeWidth: 1,
        selectable: true,
        hasBorders: false,
        hasControls: true,
        objectCaching: false,
        name: 'cropRect',
        borderColor: 'transparent',
        cornerColor: '#666',
        cornerStrokeColor: '#333',
        cornerSize: 8,
        transparentCorners: false,
      });
      this.canvas.add(this.cropRect);
      this.canvas.setActiveObject(this.cropRect);
      this.canvas.renderAll();
      // Adiciona botão para aplicar o crop
      if (!this.showCropBtn) {
        this.showCropBtn = true;
      }
    },
    applyCrop() {
      if (!this.cropRect) return;
      const rect = this.cropRect.getBoundingRect();
      
      const borderWidth = 1;
      const cropped = this.canvas.toDataURL({
        left: rect.left + borderWidth,
        top: rect.top + borderWidth,
        width: rect.width - (borderWidth * 2),
        height: rect.height - (borderWidth * 2),
        format: 'png',
      });
      this.canvas.clear();
      fabric.Image.fromURL(cropped, (img) => {
        this.canvas.setWidth(img.width);
        this.canvas.setHeight(img.height);
        
        img.borderColor = 'transparent';
        img.cornerColor = 'transparent';
        img.cornerStrokeColor = 'transparent';
        img.hasBorders = false;
        img.hasControls = false;
        img.selectable = false;
        img.stroke = 'transparent';
        img.strokeWidth = 0;
        img.borderScaleFactor = 0;
        
        img.set({
          borderColor: 'transparent',
          cornerColor: 'transparent',
          cornerStrokeColor: 'transparent',
          hasBorders: false,
          hasControls: false,
          selectable: false,
          stroke: 'transparent',
          strokeWidth: 0,
          borderScaleFactor: 0
        });
        
        this.canvas.setBackgroundImage(img, () => {
          this.canvas.backgroundColor = 'transparent';
          
          this.canvas.getObjects().forEach(obj => {
            obj.set({
              borderColor: 'transparent',
              cornerColor: 'transparent',
              cornerStrokeColor: 'transparent',
              hasBorders: false,
              hasControls: false,
              selectable: false,
              stroke: 'transparent',
              strokeWidth: 0,
              borderScaleFactor: 0
            });
          });
          
          this.canvas.renderAll();
          
          setTimeout(() => {
            this.canvas.getObjects().forEach(obj => {
              obj.set({
                borderColor: 'transparent',
                cornerColor: 'transparent',
                cornerStrokeColor: 'transparent',
                hasBorders: false,
                hasControls: false,
                selectable: false,
                stroke: 'transparent',
                strokeWidth: 0,
                borderScaleFactor: 0
              });
            });
            this.canvas.backgroundColor = 'transparent';
            this.canvas.renderAll();
          }, 100);
          
          setTimeout(() => {
            this.canvas.getObjects().forEach(obj => {
              obj.set({
                borderColor: 'transparent',
                cornerColor: 'transparent',
                cornerStrokeColor: 'transparent',
                hasBorders: false,
                hasControls: false,
                selectable: false,
                stroke: 'transparent',
                strokeWidth: 0,
                borderScaleFactor: 0
              });
            });
            this.canvas.backgroundColor = 'transparent';
            this.canvas.renderAll();
          }, 500);
        }, {
          scaleX: 1,
          scaleY: 1,
          originX: 'left',
          originY: 'top',
        });
      });
      this.cropRect = null;
      this.showCropBtn = false;
    },
    getImageEdit() {
      if (!this.canvas || !this.hasRealImage) return null;

      this.canvas.getObjects().forEach(obj => {
        if (obj.stroke) {
          obj.stroke = 'transparent';
          obj.strokeWidth = 0;
        }
      });

      this.canvas.backgroundColor = 'transparent';
      this.canvas.renderAll();

      return this.canvas.toDataURL({
        format: 'png',
        backgroundColor: 'transparent'
      });
    },
    resetCanvas() {
      if (!this.canvas) return;
      this.canvas.clear();
      this.canvas.setWidth(600);
      this.canvas.setHeight(400);
      this.canvas.backgroundColor = 'transparent';
      this.canvas.renderAll();
      this.hasRealImage = false;
      this.tempImage = '';
    }
  }
};
</script>
<style lang="scss">
.imageEditor {
  .editor-toolbar button {
    margin-right: 8px;
  }
  
  .canvas-container {
    border: none;
    max-height: 55vh;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    
    canvas {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
      border: none !important;
      outline: none !important;
    }
  }
  
  #fabric-canvas {
    border: none !important;
    outline: none !important;
  }
  
  .upper-canvas {
    border: none !important;
  }
  
  .canvas-container * {
    border: none !important;
    outline: none !important;
  }
  
  .fabric-canvas {
    border: none !important;
  }
  
  .fabric-selection {
    border: none !important;
  }
  
  .fabric-controls {
    border: none !important;
  }
  
  .fabric-corner {
    border: none !important;
    background: #666 !important;
  }
  
  .fabric-active {
    border: none !important;
  }
  
  .upper-canvas .fabric-controls {
    border: none !important;
  }
}

// Estilos específicos para o modal do ImageEditor
#directory-modal {
  .modal-dialog {
    max-width: 60vw !important;
    max-height: 85vh !important;
    margin: 10vh auto !important;
  }
  
  .modal-content {
    max-height: 85vh !important;
    overflow: hidden !important;
  }
  
  .modal-body {
    max-height: calc(85vh - 140px) !important;
    overflow: hidden !important;
    padding: 1.5rem 1rem 1rem 1rem !important;
  }
}

.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.custom-modal-content {
  background: #fff;
  padding: 24px;
  border-radius: 8px;
  min-width: 700px;
  max-width: 90vw;
  max-height: 90vh;
  overflow: auto;
}
</style>
